import I18n from './i18n/i18n';

export default {
  install(Vue, options = {}) {
    const instance = new I18n(options);
    Object.defineProperty(Vue.prototype, '$i18n', { value: instance });
  },
};
